export const BUILD_VERSION = '1790286297';
